import { apiGet, apiPost, setToken } from './api';
import { invalidate } from './useData';

export type User = {
  email: string;
  name: string;
  role: string;
  screens: string[];
  isAdmin: boolean;
  hidesFinance: boolean;
};
export type DemoUser = {
  email: string;
  name: string;
  role: string;
  role_name: string;
  ico: string;
  descr: string;
};

export async function login(email: string, password: string): Promise<User> {
  const res = await apiPost<{ token: string; user: User }>('/api/auth/login', { email, password });
  setToken(res.token); // чистит ETag-кэш запросов
  invalidate(); // и кэш экранов — чтобы не показать данные предыдущего пользователя
  return res.user;
}

export async function logout(): Promise<void> {
  await apiPost('/api/auth/logout').catch(() => {});
  setToken(null);
  invalidate();
}

export async function me(): Promise<User | null> {
  try {
    const res = await apiGet<{ user: User }>('/api/auth/me');
    return res.user;
  } catch {
    return null;
  }
}

// Перепроверка сессии: различает недействительную сессию (401) и сетевой сбой.
export type MeResult = { status: 'ok'; user: User } | { status: 'invalid' } | { status: 'error' };
export async function fetchMe(): Promise<MeResult> {
  try {
    const res = await apiGet<{ user: User }>('/api/auth/me');
    return { status: 'ok', user: res.user };
  } catch (e) {
    const msg = e instanceof Error ? e.message : '';
    if (msg.includes('401')) return { status: 'invalid' };
    return { status: 'error' };
  }
}

export async function demoUsers(): Promise<{ password: string; users: DemoUser[] }> {
  return apiGet('/api/auth/demo-users');
}
